import React from 'react';

export default ({ className, ...other }) => (
  <svg
    id="Grupo_447"
    data-name="Grupo 447"
    className={`icon w16 ${className || ''}`}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 16.609 16.609"
  >
    <g id="flaticon1567704307-svg" transform="translate(0 0)">
      <path
        id="Trazado_1129"
        data-name="Trazado 1129"
        d="M8.3,0a8.3,8.3,0,1,0,8.3,8.3A8.314,8.314,0,0,0,8.3,0Zm0,16.055A7.751,7.751,0,1,1,16.055,8.3,7.76,7.76,0,0,1,8.3,16.055Z"
        fill="#54c6e0"
      />
    </g>
    <g id="flaticon1567704432-svg" transform="translate(3.5 4.207)">
      <g id="Grupo_446" data-name="Grupo 446" transform="translate(0 0)">
        <path
          id="Trazado_1131"
          data-name="Trazado 1131"
          d="M4.848,188.429a.256.256,0,0,0,0,.363,1.067,1.067,0,0,1,0,1.508l-2.185,2.185a1.067,1.067,0,0,1-1.508,0l-.329-.329a1.067,1.067,0,0,1,0-1.508l2.185-2.185a.257.257,0,0,0-.363-.363L.464,190.285a1.578,1.578,0,0,0,0,2.234l.329.329a1.582,1.582,0,0,0,2.234,0l2.185-2.185a1.582,1.582,0,0,0,0-2.234A.256.256,0,0,0,4.848,188.429Z"
          transform="translate(0 -184.768)"
          fill="#54c6e0"
        />
        <path
          id="Trazado_1132"
          data-name="Trazado 1132"
          d="M189.509,17.39l-.329-.329a1.582,1.582,0,0,0-2.234,0l-2.185,2.185a1.582,1.582,0,0,0,0,2.234.257.257,0,1,0,.363-.363,1.067,1.067,0,0,1,0-1.508l2.185-2.185a1.067,1.067,0,0,1,1.508,0l.329.329a1.067,1.067,0,0,1,0,1.508l-2.185,2.185a.257.257,0,0,0,.18.439.25.25,0,0,0,.18-.076l2.185-2.185a1.58,1.58,0,0,0,0-2.234Z"
          transform="translate(-180.799 -16.6)"
          fill="#54c6e0"
        />
      </g>
    </g>
  </svg>
);
